var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-btns-father" },
    [
      _c("div", { staticClass: "page-btns-main" }, [
        _c("div", { staticClass: "common-title" }, [_vm._v("发票上传")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-main common no-shadow common-form-inline" },
          [
            _c(
              "a-form-model",
              {
                ref: "ruleForm",
                attrs: {
                  model: _vm.pageData,
                  "label-col": { span: 6 },
                  "wrapper-col": { span: 13 }
                }
              },
              [
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          { attrs: { label: "卖方名称" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { "white-space": "nowrap" } },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.pageData.sellrName))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "16px" } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.pageData.sellrOrgCode) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          { attrs: { label: "发票上传" } },
                          [
                            _c("invoiceUpload", {
                              staticStyle: { height: "60px" },
                              attrs: {
                                file: _vm.fileList,
                                paramObj: _vm.uploadParam,
                                name: "file",
                                pageData: _vm.pageData
                              },
                              on: { uploadOk: _vm.uploadOk }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-color-orange img-tip" },
                              [
                                _vm._v(
                                  "温馨提示：每次上传最多不可超过10张,单张发票不可超过4M。"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "common-title" }, [_vm._v("发票列表")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-common common" },
          [
            _c("a-table", {
              attrs: {
                size: "middle",
                columns: _vm.columns,
                "data-source": _vm.tableData,
                rowKey: function(record, index) {
                  return index
                },
                loading: _vm.loading,
                bordered: "",
                locale: { emptyText: "暂无数据" },
                pagination: false
              },
              scopedSlots: _vm._u([
                {
                  key: "fileNm",
                  fn: function(text, record) {
                    return [
                      _vm._v(
                        _vm._s(
                          (record.file && record.file.fileNm) ||
                            (record.file && record.file.name)
                        )
                      )
                    ]
                  }
                },
                {
                  key: "fileRte",
                  fn: function(text, record) {
                    return [
                      _c("img", {
                        attrs: {
                          src: _vm.getImgUrl(record.file),
                          alt: "",
                          srcset: "",
                          width: "40"
                        },
                        on: {
                          click: function($event) {
                            return _vm.preview(record.file)
                          }
                        }
                      })
                    ]
                  }
                },
                {
                  key: "errmsg",
                  fn: function(text, record) {
                    return [
                      _vm._v(
                        _vm._s((record.file && record.file.errmsg) || "成功")
                      )
                    ]
                  }
                },
                {
                  key: "invoiceType",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("invoiceTypeFilter")(text)) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "invoiceCode",
                  fn: function(text, record) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(+record.invoiceType === 4 ? "--" : text) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "invoiceAmountWithVat",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("splitK")(text)) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "invoiceAmount",
                  fn: function(text) {
                    return [_vm._v(_vm._s(_vm._f("splitK")(text)))]
                  }
                },
                {
                  key: "checkCode",
                  fn: function(text, record) {
                    return [
                      _vm._v(
                        _vm._s(
                          +record.invoiceType === 0 || +record.invoiceType === 1
                            ? "--"
                            : text
                        )
                      )
                    ]
                  }
                },
                {
                  key: "payableAmount",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("splitK")(text)) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "oper",
                  fn: function(text, record, index) {
                    return [
                      record.file && record.file.errmsg
                        ? _c(
                            "a-button",
                            {
                              attrs: { type: "link" },
                              on: {
                                click: function($event) {
                                  return _vm.handleDel(record, index)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "link" },
                          on: {
                            click: function($event) {
                              return _vm.handleEdit(record, index)
                            }
                          }
                        },
                        [_vm._v("修改")]
                      ),
                      _vm._v(" "),
                      record.id
                        ? _c(
                            "a-button",
                            {
                              attrs: { type: "link" },
                              on: {
                                click: function($event) {
                                  return _vm.toInvInfo(record)
                                }
                              }
                            },
                            [_vm._v("查看")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      record.id
                        ? _c(
                            "a-button",
                            {
                              attrs: { type: "link" },
                              on: {
                                click: function($event) {
                                  return _vm.toRevoke(record, index)
                                }
                              }
                            },
                            [_vm._v("撤销")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "text-color-orange" }, [
              _vm._v(
                "温馨提示：请据实填写标的单据（发票）对应的应付金额，应付金额不可大于发票金额（含税）。"
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter page-bottom-btns" },
        [
          _c(
            "a-button",
            {
              staticClass: "btn-blue-line",
              staticStyle: { margin: "0 5px" },
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c("button-load", {
            attrs: { type: "primary", lable: "去查验" },
            on: { clickHandle: _vm.gotoCheck }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("invoiceInfo", {
        ref: "invoiceInfo",
        attrs: { info: _vm.curRow, readonly: _vm.readonly, btns: _vm.btns },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          },
          success: _vm.getRowInfo
        }
      }),
      _vm._v(" "),
      _c("payableImportReslut", { ref: "payableImportReslut" }),
      _vm._v(" "),
      _c("imgView", {
        ref: "imgView",
        attrs: { src: _vm.viewSrc },
        on: {
          "update:src": function($event) {
            _vm.viewSrc = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0dc61b25", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dc61b25","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-manage/payable/payable-import.vue
// module id = +FIx
// module chunks = 1